import React from 'react';

const SomethingWentWrong = () => {
  return (
    <main
      className="govuk-main-wrapper govuk-main-wrapper--auto-spacing"
      id="content"
      role="main"
      tabIndex={0}
    >
      <h1 data-test="error-header">
        Sorry, there is a problem with the service
      </h1>
      <p data-test="error-text-1">
        The service is currently experiencing an issue, please retry later.
      </p>
      <p data-test="error-text-2">
        If you cannot use this online service, call the anti-terrorism hotline {' '}
        <a href="tel:+0800789321">0800 789 321</a>.
        The hotline is staffed 24/7.
      </p>  
    </main>
  );
};
export default SomethingWentWrong;
